import React, {Component} from 'react';
import {connect} from "react-redux";
import AutoComplete from "antd/es/auto-complete";
import Input from "antd/es/input";
import {jsforceResponse} from "@/config/httpService";
import styled from "styled-components";
import {debounce} from "lodash";

export const SearchLookupWrapper = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  vertical-align: middle;
`


class SearchLookup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            record: null,
            value: null,
            dropdownVisible: false,
            loading: false
        }
        this.debouncedHandleSearch = debounce(this.handleSearch2, 100);
    }

    componentDidMount() {
        // console.log('default', this.props.defaultValue)
        this.setState({
            value: this.props.defaultValue
        })
    }


    handleFocus = async (e) => {
        this.setState({dropdownVisible: true, loading: true});
        let options = [];
        const result = await this.props.Lookup_CommonupRequest('');
        const res = jsforceResponse(result, '', false, true)
        console.log('res', res)
        let existingKeys = new Set();
        for (let i = 0; i < res.data?.length; i++) {
            if (!existingKeys.has(res.data[i][this.props.name])) {
                options.push({
                    key: res.data[i].id,
                    value: res.data[i][this.props.name],
                    label: res.data[i][this.props.name],
                    record: res.data[i].id
                })
                existingKeys.add(res.data[i][this.props.name]);
            }
        }
        this.setState({
            options,
            loading: false
        })
    }

    handleSearch = async (e) => {
        this.setState({dropdownVisible: true});
        this.setState({value: e})
        this.props.onFilterValueChange?.({
            [this.props.name || this.props.placeholder || 'search']: e,
        });
        this.debouncedHandleSearch(e)
    }

    handleEnterSearch = async (e) => {
        this.setState({value: e, dropdownVisible: false})
        this.props.onFilterValueChange?.({
            [this.props.name || this.props.placeholder || 'search']: e,
        });
        this.props.SelectedLookup_CommonRequest(e)
    }

    handleSearch2 = async (e) => {
        this.setState({
            loading: true
        })
        let options = [];
        const result = await this.props.Lookup_CommonupRequest(e);
        const res = jsforceResponse(result, '', false, true)
        let existingKeys = new Set();
        for (let i = 0; i < res.data?.length; i++) {
            if (!existingKeys.has(res.data[i][this.props.name])) {
                options.push({
                    key: res.data[i].id,
                    value: res.data[i][this.props.name],
                    label: res.data[i][this.props.name],
                    record: res.data[i].id
                })
                existingKeys.add(res.data[i][this.props.name]);
            }
        }
        this.setState({
            options,
            loading: false
        })
    }

    handleSelect = (e, record) => {
        this.setState({value: e, dropdownVisible: false})
        this.props.onFilterValueChange?.({
            [this.props.name || this.props.placeholder || 'search']: e,
        });
        this.props.SelectedLookup_CommonRequest(e, record)
    }

    renderMobileOptions = () => {
        if (!this.state.dropdownVisible) {
            return null;
        }

        if (this.state.loading) {
            return (
                <div className="search-lookup-mobile-options">
                    <div className="search-lookup-mobile-option search-lookup-mobile-option-muted">
                        Loading...
                    </div>
                </div>
            );
        }

        if (!this.state.options.length) {
            return (
                <div className="search-lookup-mobile-options">
                    <div className="search-lookup-mobile-option search-lookup-mobile-option-muted">
                        No options
                    </div>
                </div>
            );
        }

        return (
            <div className="search-lookup-mobile-options">
                {this.state.options.map((option) => (
                    <button
                        key={option.key || option.value}
                        type="button"
                        className="search-lookup-mobile-option"
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={() => this.handleSelect(option.value, option)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        );
    }


    render() {
        // console.log('SearchLookup', this.props.options)
        if (this.props.isPC === false) {
            return (
                <SearchLookupWrapper>
                    <div className="search-lookup-mobile">
                        <Input.Search
                            size="medium"
                            style={{ width: 220, textAlign: 'center', ...this.props.style }}
                            value={this.state.value}
                            defaultValue={this.state.value}
                            placeholder={this.props.placeholder}
                            allowClear
                            enterButton
                            onFocus={this.handleFocus}
                            onChange={(event) => this.handleSearch(event.target.value)}
                            onSearch={this.handleEnterSearch}
                        />
                        {this.renderMobileOptions()}
                    </div>
                </SearchLookupWrapper>
            );
        }

        return (
            <SearchLookupWrapper>
                <AutoComplete
                    // placeholder={this.props.label}
                    style={{ width: 220, ...this.props.style }}
                    options={this.state.options}
                    onFocus={this.handleFocus}
                    onSelect={this.handleSelect}
                    onSearch={this.handleSearch}
                    // onChange={this.handleOnChange}
                    onBlur={() => {
                        this.setState({dropdownVisible: false});
                    }}
                    value={this.state.value}
                    defaultValue={this.state.value}
                    dropdownMatchSelectWidth={false}
                    placeholder={this.props.placeholder}
                    open={this.state.dropdownVisible}
                    loading={this.props.loading}
                >
                    <Input.Search size="medium" style={{textAlign: 'center'}}
                                  onSearch={this.handleEnterSearch}
                                  allowClear enterButton/>
                </AutoComplete>
            </SearchLookupWrapper>
        );
    }

}

SearchLookup.displayName = "SearchLookup";

const mapStateToProps = state => {
    return {
        isPC: state.App?.isPC,
    }
};
const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchLookup);
